<template>
  <article>
    <div class="container-fluid">
      <div class="row">
        <div class="col px-0">
          <SectionTitle has-line title="Ubicación del asistente" />
        </div>
      </div>
    </div>
    <div class="bg-light-gray border-radius--light">
      <div class="row p-3">
        <div class="col-12 col-md-3">
          <ValidationProvider
            v-slot="{ errors }"
            name="Region"
            rules="required"
          >
            <label class="text-muted mb-1">Región:</label>
            <CustomDropDown
              v-model="assistantLocation.region"
              placeholder="Seleccione"
              class="placeholder-black"
              fieldkey="id"
              fieldname="name"
              :options="collections.regions"
              :disabled="isDropDownRegionDisabled || readonly"
              :clearable="false"
              :error="errors[0]"
            />
            <CustomError
              v-if="errors[0]"
              variant="no-border"
              message="Favor seleccione una región."
            />
          </ValidationProvider>
        </div>
        <div class="col-12 col-md-3">
          <ValidationProvider
            v-slot="{ errors }"
            name="Municipio"
            rules="required"
          >
            <label class="text-muted mb-1">Municipio:</label>
            <CustomDropDown
              v-model="assistantLocation.municipality"
              placeholder="Seleccione"
              class="placeholder-black"
              fieldkey="id"
              fieldname="name"
              :options="collections.municipalities"
              :disabled="isDropDownMunicipalityIdDisabled || readonly"
              :error="errors[0]"
              @input="onChangeMunicipality"
            />
            <CustomError
              v-if="errors[0]"
              variant="no-border"
              message="El municipio es requerido."
            />
          </ValidationProvider>
        </div>
        <div class="col-12 col-md-6">
          <ValidationProvider
            ref="schoolValidator"
            v-slot="{ errors }"
            name="Escuela"
            rules="required"
          >
            <label class="text-muted mb-1">Escuela:</label>
            <CustomDropDown
              v-model="assistantLocation.school"
              placeholder="Seleccione"
              class="placeholder-black"
              fieldkey="id"
              fieldname="name"
              :options="collections.schools"
              :disabled="isDropDownSchoolDisabled || readonly"
              :error="errors[0]"
            />
            <CustomError
              v-if="errors[0]"
              variant="no-border"
              message="La escuela es requerida."
            />
          </ValidationProvider>
        </div>
        <div class="col dropdown-divider mt-4 pb-3 mx-3" />
        <div class="col-12">
          <ValidationProvider
            v-slot="{ errors }"
            name="Comentario"
            rules="required"
          >
            <label class="text-muted mb-1">Comentario:</label>
            <CustomTextArea
              v-model="assistantLocation.comment"
              :maxlength="3000"
              :classes="['text-right']"
              :rows="2"
              :error="errors[0]"
              custom-error-msg="El comentario es requerido."
              show-char-count
              :disabled="readonly"
            />
          </ValidationProvider>
        </div>
      </div>
    </div>
  </article>
</template>

<script>
import SectionTitle from 'SectionTitle';
import CustomTextArea from 'CustomTextArea';
import CustomDropDown from 'custom-drop-down';
import CustomError from 'custom-error';
import { ValidationProvider } from 'vee-validate';
import locationService from '@/services/api/location.api.js';

export default {
  name: 'AssistantLocation',
  components: {
    SectionTitle,
    CustomTextArea,
    CustomDropDown,
    CustomError,
    ValidationProvider,
  },
  props: {
    assistantLocation: {
      type: Object,
      default: () => null,
      required: true,
    },
    academicYearId: {
      type: Number,
      default: () => null,
      required: true,
    },
    collections: {
      type: Object,
      required: true,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {};
  },
  computed: {
    isDropDownRegionDisabled() {
      return this.collections.regions && this.collections.regions.length <= 1;
    },
    isDropDownMunicipalityIdDisabled() {
      return (
        this.collections.municipalities &&
        this.collections.municipalities.length <= 1
      );
    },
    isDropDownSchoolDisabled() {
      return this.collections.schools && this.collections.schools.length <= 1;
    },
  },
  methods: {
    async onChangeMunicipality(municipality) {
      this.assistantLocation.school = null;
      this.collections.schools = [];
      this.$refs.schoolValidator.reset();
      if (municipality) {
        await this.fetchSchools(municipality.id);
      }
    },
    async fetchSchools(municipalityId) {
      const { data } = await locationService.getSchools({
        municipalityId,
        academicYearId: this.academicYearId,
        IgnoreUserProfile: true,
      });
      this.collections.schools = data;
    },
  },
  async created() {
    if (
      this.collections.municipalities &&
      this.collections.municipalities.length == 1
    ) {
      this.assistantLocation.municipality = this.collections.municipalities[0];
      await this.fetchSchools(this.assistantLocation.municipality.id);
    }
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/variables/_colors.scss';
.dropdown-divider {
  border-top: 1px solid $gray_5;
}
</style>
